// extracted by mini-css-extract-plugin
module.exports = {"error":"error__34HoU+xxBDCHW","marker":"marker__rs2PgI247kOc2","text":"text__n3nu0McuJw8IU"};